export type creditCardInfoErrors = {
	firstName: boolean;
	lastName: boolean;
	cardNumber: boolean;
	cardNumberNotValid: boolean;
	expirationMonth: boolean;
	expirationYear: boolean;
	cardExpired: boolean;
	cvv: boolean;
	cvvNotValid: boolean;
};

export const creditCardInfoErrorsDefault = {
	firstName: false,
	lastName: false,
	cardNumber: false,
	cardNumberNotValid: false,
	expirationMonth: false,
	expirationYear: false,
	cardExpired: false,
	cvv: false,
	cvvNotValid: false,
};

type Props = {
	firstName: string;
	lastName: string;
	cardNumber: string;
	expirationMonth: string;
	expirationYear: string;
	cvv: string;
};

const visaRegEx = /^4[0-9]{12}(?:[0-9]{3})?$/;
const mastercardRegEx = /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/;
const amexpRegEx = /^3[47][0-9]{13}$/;
const discovRegEx = /^6(?:011|5[0-9]{2})[0-9]{12}$/;

const validateCreditCardInfo = ({ firstName, lastName, cardNumber, expirationMonth, expirationYear, cvv }: Props) => {
	const errors: creditCardInfoErrors = { ...creditCardInfoErrorsDefault };

	errors.firstName = firstName === '';
	errors.lastName = lastName === '';
	errors.cardNumber = cardNumber === '';
	errors.expirationMonth = expirationMonth === '';
	errors.expirationYear = expirationYear === '';
	errors.cvv = cvv === '';

	if (cardNumber === '' || !(visaRegEx.test(cardNumber) || mastercardRegEx.test(cardNumber) || amexpRegEx.test(cardNumber) || discovRegEx.test(cardNumber))) {
		errors.cardNumberNotValid = true;
	} else {
		errors.cardNumberNotValid = false;
	}

	// Check if a card has expired
	const currentDate = new Date();
	const intExpirationMonth = parseInt(expirationMonth);
	const intExpirationYear = parseInt(expirationYear);
	const expirationDate = new Date(intExpirationYear, intExpirationMonth);
	if (currentDate >= expirationDate) {
		errors.cardExpired = true;
	}

	if ((amexpRegEx.test(cardNumber) && cvv.length !== 4) || (!amexpRegEx.test(cardNumber) && cvv.length !== 3)) {
		errors.cvvNotValid = true;
	}

	return errors;
};

export default validateCreditCardInfo;
